import { toLowerCase, toUpperCase } from "./string-utils";

// Mapa de funciones
export const FUNCTION_MAP = {
  toUpperCase,
  toLowerCase
};

// Tipo seguro con los nombres válidos
export type FunctionName = keyof typeof FUNCTION_MAP;

function isValidFunctionName(name: string): name is FunctionName {
  return name in FUNCTION_MAP;
}

// executeFunction(functionName, value);
export function executeFunction(functionName: string, value: unknown) {
  if (!isValidFunctionName(functionName))
    throw new Error(`Función no válida: ${functionName}`);

  const fn = FUNCTION_MAP[functionName];
  return fn(value as never);
}